import React from 'react';

export const OAuth2Providers = [
  {
    id: 'auth0',
    name: 'Auth0',
    icon: (
      <img src="assets/img/auth0.png" id="auth0" />
    )
  }
];
